import { useEffect, useState } from 'react';

import { Avatar, AvatarProps } from '@material-ui/core';

type ContactAvatarProps = AvatarProps;

export function ContactAvatar({ src, ...avatarProps }: ContactAvatarProps) {
  const [loadedSrc, setLoadedSrc] = useState<string>();

  useEffect(() => {
    if (!src) {
      setLoadedSrc(undefined);
      return undefined;
    }

    const img = new Image();

    img.onload = () => setLoadedSrc(src);
    img.onerror = () => setLoadedSrc(undefined);
    img.src = src;

    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [src]);

  return <Avatar {...avatarProps} src={loadedSrc} />;
}
